import React, {Component} from 'react';
import cx from 'classnames';

export default class PhotoThumbnail extends Component {
    render(){
        const {photo, isNotActive, selectPhoto} = this.props;
        const classnames = cx('photo-thumbnail', {'photo-thumbnail-not-selected': isNotActive});
        const style={
            backgroundImage: `url(${photo.imgPath})`,
            backgroundSize: 'cover'
        };

        return(
            <div
                className={classnames}
                onClick={selectPhoto}
                style={style}>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/photo_selector/photo_thumbnail.js